const [majorVersion] = window.OC?.config?.version?.split(".") ?? [];
const major = Number.parseInt(majorVersion ?? "35");
const isLegacy = major < 32;
const isLegacy34 = major < 34;
const isLegacy35 = major < 35;
export {
  isLegacy as a,
  isLegacy35 as b,
  isLegacy34 as i
};
//# sourceMappingURL=legacy.mjs.map
